import submitTraining from "@crescentParts/Handlers/Custom/TrainingRegistrationHandler";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Select from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    submitTraining,
    loadCurrentCart
};
const mapStateToProps = (state: ApplicationState, props: OwnProps & HasProductContext) => {
    const {
        productSettings: { showAddToCartConfirmationDialog },
    } = getSettingsCollection(state);

    const isCartLoading = getCurrentCartState(state).isLoading;
    const { isUpdatingCart } = state.context;
    return {
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
        isAddToCartButtonDisabled: isCartLoading || isUpdatingCart,
        showAddToCartConfirmationDialog,
    }
}
interface OwnProps {
    selectedTraining: string;
    selectedAddress: string;
    selectedStartDate: string;
    selectedEndDate: string;
    isOpen?: boolean;
    trainingQty?: any;
    closeModalHandler?: () => void;
    cartPageUrl?: string;
    isCheckInventory?: boolean;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;
export interface RegistrationPopupStyle {
    modal?: ModalPresentationProps;
    trainingNameWrapper?: InjectableCss;
    trainingNameLabel?: TypographyPresentationProps;
    trainingName?: TypographyPresentationProps;
    nameFieldInfoText?: TypographyPresentationProps;
    formTextField?: TextFieldPresentationProps;
    ctaButtonsWrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
    formContent?: InjectableCss;
    paymentSelect?: InjectableCss;
    addMoreEmailField?: InjectableCss;
    removeEmailField?: InjectableCss;
    gridContainer?: GridContainerProps;
    genericTextGirdItem?: GridItemProps;
    opertorIcons?: InjectableCss;
}

export const registrationPopupStyle: RegistrationPopupStyle = {
    modal: {
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
                [class^="ButtonWrapper"] {
                    border: solid 2px;
                    border-radius: 50%;
                }
                svg {
                    height: 20px;
                    width: 20px;
                }
                [class^="IconWrapper"] {
                    top: 0em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            `,
            modalContent: css`
                padding: 0px;
            `,
            modalContainer: css`
                height: 100vh;
                align-items: center;
                [class^="ContentBody"] {
                    max-height: 100vh;
                    max-width: 100%;
                    width: 1180px;
                }
                [class^="FormInputWrapper"] {
                    [class^="DescriptionWrapper"] {
                        margin-top: 0;
                    }
                }
            `,
        },
    },
    trainingNameWrapper: {
        css: css`
            margin-bottom: 21px;
        `,
    },
    trainingNameLabel: {
        weight: 600,
        size: 14,
        color: "text.accent",
        css: css`
            margin-bottom: 5px;
        `,
    },
    trainingName: {
        variant: "p",
        css: css`
            margin-bottom: 0;
        `,
    },
    formTextField: {
        cssOverrides: {
            formInputWrapper: css`
                margin-top: 4px !important;
            `,
            descriptionWrapper: css`
                span {
                    margin: -29px 0px 0px 0px !important;
                }
            `,
        },
        labelProps: {
            size: 14,
            weight: 600,
        },
        css: css`
            border-radius: 8px !important;
            padding: 0px;
            background: pink;
            margin-bottom: 20px;
            position: relative;
        `,
    },
    nameFieldInfoText: {
        css: css`
            // position: absolute;
            // left: 19px;
            font-size: 11px;
            // top: 135px;
        `,
    },
    ctaButtonsWrapper: {
        css: css`
            border-top: 1px solid ${getColor("common.border")};
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 20px;
        `,
    },
    submitButton: {
        variant: "primary",
    },
    cancelButton: {
        variant: "secondary",
    },
    formContent: {
        css: css`
            padding: 20px;
        `,
    },
    paymentSelect: {
        css: css`
            border-radius: 8px !important;
            padding: 0px;
        `,
    },
    addMoreEmailField: {
        css: css`
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
        `,
    },
    removeEmailField: {
        css: css`
            font-size: 24px;
            font-weight: bold;
            cursor: pointer;
        `,
    },
    gridContainer: {
        css: css`
            padding: 20px 45px;
            background: #f6f4f6;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100%;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    genericTextGirdItem: {
        width: [12, 12, 6, 4, 4],
        css: css`
            position: relative;
        `,
    },
    opertorIcons: {
        css: css`
            width: 20px;
            height: 20px;
            margin: 20px 7px;
            cursor: pointer;
        `,
    }
};

const styles = registrationPopupStyle;
const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
const StyledForm = getStyledWrapper("form");

export const TrainingRegistrationPopup = ({
    selectedTraining,
    isOpen,
    closeModalHandler,
    submitTraining,
    selectedAddress,
    selectedStartDate,
    selectedEndDate,
    cartPageUrl,
    history,
    trainingQty,
    loadCurrentCart,
    isCheckInventory
}: Props) => {
    const nameRequiredFieldMessage = siteMessage("Training_Form_nameError");
    const companyNameRequiredFieldMessage = siteMessage("Training_Form_companyError");
    const emailRequiredFieldMessage = siteMessage("Training_Form_emailError");
    const phoneRequiredFieldMessage = siteMessage("Training_Form_phoneError");
    const tmRequiredFieldMessage = siteMessage("Training_Form_tmError");
    const joinCountRequiredFieldMessage = siteMessage("Training_Form_joiningCountError");
    const validemailMsg = siteMessage("Training_Form_ValidEmail");
    const validPhoneMsg = siteMessage("Training_Form_ValidPhone");
    const userFieldsInitialValues = {
        name: "",
        nameError: nameRequiredFieldMessage,
        email: "",
        emailError: emailRequiredFieldMessage,
        phone: "",
        phoneError: phoneRequiredFieldMessage
    }
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState(nameRequiredFieldMessage);
    const [companyName, setCompanyName] = useState("");
    const [companyNameError, setCompanyNameError] = useState(companyNameRequiredFieldMessage);
    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(emailRequiredFieldMessage);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState(phoneRequiredFieldMessage);
    const [tm, setTm] = useState("");
    const [tmError, setTmError] = useState(tmRequiredFieldMessage);
    const [paymentMethod, setPaymentMethod] = useState("On Account");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [userFields, setUserFields] = useState([{ ...userFieldsInitialValues }]);

    const [totalJoiningCount, setTotalJoiningCount] = useState("");
    const [totalJoiningCountError, setTotalJoiningCountError] = useState(joinCountRequiredFieldMessage);
    const toasterContext = useContext(ToasterContext);

    useEffect(() => {
        // Clear old form data everytime popup shows up
        if (isOpen) {
            clearForm();
        }
    }, [isOpen]);

    const validateName = (name: string) => {
        const errorMessage = !name ? nameRequiredFieldMessage : "";
        setNameError(errorMessage);
        return !errorMessage;
    };

    const validateCompanyName = (name: string) => {
        const errorMessage = !name ? companyNameRequiredFieldMessage : "";
        setCompanyNameError(errorMessage);
        return !errorMessage;
    };
    
    const validateTotalJoingingCount = (count: string) => {
        const errorMessage = !count ? joinCountRequiredFieldMessage : "";
        setTotalJoiningCountError(errorMessage);
        return !errorMessage;
    };

    const validateUserFields = (key: string, value: string, index: number) => {
        const userFieldArr = [...userFields];
        let errorMessage: any = "";
        let phoneValue = "";
        switch(key) {
            case "name":
                errorMessage = !value ? nameRequiredFieldMessage : ""
                userFieldArr.map((userField, i) => {
                    if(i === index) {
                        userField.nameError = errorMessage;
                    }
                    return userField;
                });
                setUserFields(userFieldArr);
              break;
            case "email":
                errorMessage = !value ? emailRequiredFieldMessage : emailRegexp.test(value) ? "" : validemailMsg;
                userFieldArr.map((userField, i) => {
                    if(i === index) {
                        userField.emailError = errorMessage;
                    }
                    return userField;
                });
                setUserFields(userFieldArr);
              break;
            case "phone":
                phoneValue = removeDashFromPhone(value);
                errorMessage = !phoneValue ? phoneRequiredFieldMessage : Number(phoneValue) && phoneValue.length === 10 ? ""
                : validPhoneMsg;
                userFieldArr.map((userField, i) => {
                    if(i === index) {
                        userField.phoneError = errorMessage;
                    }
                    return userField;
                });
                setUserFields(userFieldArr);
              break;
          }
        return !errorMessage;
    };

    const validateEmail = (email: string) => {
        const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : validemailMsg;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    const validatePhone = (value: string) => {
        value = removeDashFromPhone(value);
        const errorMessage = !value
            ? phoneRequiredFieldMessage
            : Number(value) && value.length === 10
            ? ""
            : validPhoneMsg;
        setPhoneError(errorMessage);
        return !errorMessage;
    };

    const validateSubmitEnabled = () => {
        let isError = trainingQty === 0 ? totalJoiningCountError : false
        userFields.forEach((fields) => {
            if(fields.nameError || fields.emailError || fields.phoneError) {
                isError = true;
            }
        })
        return !isError;
        // return !(nameError || companyNameError || emailError || phoneError);
    };

    const nameChangeHandler = (value: string) => {
        setName(value);
        validateName(value);
    };

    const companyNameChangeHandler = (value: string) => {
        setCompanyName(value);
        validateCompanyName(value);
    };
    
    const joingCountChangeHandler = (value: string) => {
        const regex = /[0-9]|\./;
        if (!regex.test(value) || value.length > 10) {
            return;
        }
        setTotalJoiningCount(value);
        validateTotalJoingingCount(value);
    };

    const userFieldsChangeHandler = (key: string, value: string, index: number) => {
        let formattedPhone = value;
        const regex = /[0-9]|\./;
        if(key === "phone") {
            value = removeDashFromPhone(value);
            if (!regex.test(value) || value.length > 10) {
                return;
            }
            if (value) {
                formattedPhone = addDashToPhone(value);
            }
            validateUserFields(key, formattedPhone, index);
        } else {
            validateUserFields(key, value, index);
        }
        
        const arr = [...userFields];
        arr.map((field: any, i) => {
            if(i === index) {
                field[key] = key === "phone" ? formattedPhone : value;
            }
            return field;
        });
        setUserFields(arr);
        setIsSubmitted(false);
    };

    const emailChangeHandler = (value: string) => {
        setEmail(value);
        validateEmail(value);
    };

    const tmChangeHandler = (value: string) => {
        setTm(value);
    };

    const paymentChangeHandler = (value: string) => {
        setPaymentMethod(value);
    };

    const addDashToPhone = (value: string) => {
        if (value.length > 6) {
            return `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
        }
        if (value.length > 3 && value.length <= 6) {
            return `${value.slice(0, 3)}-${value.slice(3, 6)}`;
        }
        return value;
    };

    const phoneChangeHandler = (value: string) => {
        const regex = /[0-9]|\./;
        if (!value) {
            setPhone("");
            validatePhone(value);
        }
        value = removeDashFromPhone(value);
        if (!regex.test(value) || value.length > 10) {
            return;
        }
        if (value) {
            const formattedPhone = addDashToPhone(value);
            formattedPhone !== undefined && setPhone(formattedPhone);
            validatePhone(formattedPhone);
        }
    };

    const removeDashFromPhone = (value: string) => {
        return value.replace(/\D/g, "");
    };

    const onSuccessHandler = (result: any) => {
        setErrorMessage("");
        // toasterContext.addToast({ body: translate("Successfully submitted!"), messageType: "success" });
        if(result?.productId === "" && trainingQty !== 0) {
            toasterContext.addToast({ body: siteMessage("Training Product not found"), messageType: "warning" });
        } else {
            toasterContext.addToast({ body: siteMessage("Successfully submitted!"), messageType: "success" });
        }
        
        loadCurrentCart({ 
            shouldLoadFullCart: true, 
            replaceCart: true,
            onSuccess: () => {
                if (cartPageUrl && result?.productId !== "") {
                    history.push(cartPageUrl);
                }
            }
        });     
        closeModalHandler?.();
        clearForm();
        
    };

    // eslint-disable-next-line require-await
    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            return;
        }

        setIsSubmitting(true);

        submitTraining({
            TrainingName: selectedTraining,
            Location: selectedAddress,
            StartDate: selectedStartDate,
            EndDate: selectedEndDate,
            Name: userFields.map(userField => userField.name).join(","),
            CompanyName: companyName,
            Phone: userFields.map(userField => userField.phone).join(","),
            Email: userFields.map(userField => userField.email).join(","),
            TM: tm,
            PaymentMethod: paymentMethod,
            totalJoiningCount: trainingQty === 0 ? `${totalJoiningCount}` : "",
            onSuccess: (result) => {
                onSuccessHandler(result);
            },
            onError: error => {
                setErrorMessage(error);
                setIsSubmitting(false);
                const errorMsg = error.toString().length > 400 ? "Something went wrong!" : error;
                toasterContext.addToast({ body: translate(errorMsg), messageType: "danger" });
            },
        });
    };

    const clearForm = () => {
        setName("");
        setCompanyName("");
        setEmail("");
        setPhone("");
        setTm("");
        setPaymentMethod("On Account");
        setErrorMessage("");
        setIsSubmitted(false);
        setIsSubmitting(false);
        setNameError(nameRequiredFieldMessage);
        setCompanyNameError(companyNameRequiredFieldMessage);
        setEmailError(emailRequiredFieldMessage);
        setPhoneError(phoneRequiredFieldMessage);
        setTmError(tmRequiredFieldMessage);
        setUserFields([{ ...userFieldsInitialValues }])
    };

    const addMoreEmailField = () => {
        const arr = [...userFields];
        arr.push({ ...userFieldsInitialValues })
        setUserFields(arr);
        setIsSubmitted(false);
    }

    const removeEmailField = (index: number) => {
        const arr = [...userFields];
        arr.splice(index, 1)
        setUserFields(arr);
        setIsSubmitted(false);
    }
    const isSubmitEnabled = validateSubmitEnabled();

    return (
        <Modal {...styles.modal} headline="Register Now" isOpen={isOpen} handleClose={closeModalHandler}>
            <StyledForm onSubmit={submitHandler}>
                <StyledWrapper {...styles.formContent}>
                    <StyledWrapper {...styles.trainingNameWrapper}>
                        <Typography {...styles.trainingNameLabel}>Training Name</Typography>
                        <Typography {...styles.trainingName}>{selectedTraining}</Typography>
                    </StyledWrapper>
                    <StyledWrapper>
                        {/* <TextField
                            {...styles.formTextField}
                            type="text"
                            label={translate("Name*")}
                            onChange={e => nameChangeHandler(e.currentTarget.value)}
                            value={name}
                            error={isSubmitted && nameError}
                        /> */}
                        {!isCheckInventory &&
                        <Typography {...styles.nameFieldInfoText}>
                            {trainingQty === 0 ? "Seat Availability - Class Full": `Seat Availability - Only ${trainingQty || ""} Seats Left!`}
                            {/* {`Seat Availability - Only ${trainingQty || ""} Seats Left!`} */}
                            {/* {translate("Each attendee requires their own registration.")} */}
                        </Typography>
                        }
                    </StyledWrapper>
                    <Typography {...styles.nameFieldInfoText}>
                        {translate("Each attendee requires their own registration.")}
                    </Typography>
                    {trainingQty === 0 && <GridContainer>
                        <GridItem {...styles.genericTextGirdItem}>
                            <TextField
                                {...styles.formTextField}
                                type="text"
                                label={translate("Team members count to join training*")}
                                onChange={e => joingCountChangeHandler(e.currentTarget.value)}
                                value={totalJoiningCount}
                                error={isSubmitted && totalJoiningCountError}
                            />
                        </GridItem>
                    </GridContainer>}
                    {/* <StyledWrapper>
                        <TextField
                            {...styles.formTextField}
                            type="text"
                            label={translate("Company Name*")}
                            onChange={e => companyNameChangeHandler(e.currentTarget.value)}
                            value={companyName}
                            error={isSubmitted && companyNameError}
                        />
                    </StyledWrapper>
                    <StyledWrapper>
                        <TextField
                            {...styles.formTextField}
                            type="text"
                            label={translate("Email*")}
                            onChange={e => emailChangeHandler(e.currentTarget.value)}
                            value={email}
                            error={isSubmitted && emailError}
                        />
                    </StyledWrapper>
                    <StyledWrapper>
                        <TextField
                            {...styles.formTextField}
                            type="text"
                            label={translate("Cell Phone*")}
                            onChange={e => phoneChangeHandler(e.currentTarget.value)}
                            value={phone}
                            error={isSubmitted && phoneError}
                        />
                    </StyledWrapper>
                    <StyledWrapper>
                        <TextField
                            {...styles.formTextField}
                            type="text"
                            label={translate("TM")}
                            onChange={e => tmChangeHandler(e.currentTarget.value)}
                            value={tm}
                        />
                    </StyledWrapper>
                    <StyledWrapper>
                        <Select
                            {...styles.paymentSelect}
                            label={translate("Payment Method*")}
                            defaultValue="On Account"
                            onChange={e => paymentChangeHandler(e.currentTarget.value)}
                            value={paymentMethod}
                        >
                            <option value="On Account">On Account</option>
                            <option value="Credit Card">Credit Card</option>
                        </Select>
                    </StyledWrapper> */}
                    
                    <GridContainer {...styles.gridContainer}>
                        <GridItem {...styles.genericTextGirdItem}>
                            <TextField
                                {...styles.formTextField}
                                type="text"
                                label={translate("Company Name*")}
                                onChange={e => companyNameChangeHandler(e.currentTarget.value)}
                                value={companyName}
                                error={isSubmitted && companyNameError}
                            />
                        </GridItem>
                        <GridItem {...styles.genericTextGirdItem}>
                            <TextField
                                {...styles.formTextField}
                                type="text"
                                label={translate("TM")}
                                onChange={e => tmChangeHandler(e.currentTarget.value)}
                                value={tm}
                            />
                        </GridItem>
                    </GridContainer>
                    <GridContainer {...styles.gridContainer}>
                        {userFields.map((userField: any, i: number) => {
                            return (
                                <React.Fragment key={i}>
                                    <GridItem {...styles.genericTextGirdItem} key={`name-GridItem${i}`}>
                                        <TextField
                                            key={`name-text${i}`}
                                            {...styles.formTextField}
                                            type="text"
                                            label={translate("Name*")}
                                            onChange={e => userFieldsChangeHandler("name", e.currentTarget.value, i)}
                                            value={userField.name}
                                            name={`name-${i}`}
                                            error={isSubmitted && userField.nameError}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.genericTextGirdItem} key={`email-GridItem${i}`}>
                                        <TextField
                                            key={`email-GridItem${i}`}
                                            {...styles.formTextField}
                                            type="text"
                                            label={translate("Email*")}
                                            onChange={e => userFieldsChangeHandler("email", e.currentTarget.value, i)}
                                            value={userField.email}
                                            name={`email-${i}`}
                                            error={isSubmitted && userField.emailError}
                                        />
                                    </GridItem>
                                    <GridItem {...styles.genericTextGirdItem} key={`phone-GridItem${i}`}>
                                        <TextField
                                            key={`phone-GridItem${i}`}
                                            {...styles.formTextField}
                                            type="text"
                                            label={translate("Cell Phone*")}
                                            onChange={e => userFieldsChangeHandler("phone", e.currentTarget.value, i)}
                                            value={userField.phone}
                                            name={`phone-${i}`}
                                            error={isSubmitted && userField.phoneError}
                                        />
                                        <GridItem {...styles.genericTextGirdItem} key={`icon-GridItem${i}`}>
                                            {isCheckInventory ? <StyledWrapper {...styles.opertorIcons} onClick={addMoreEmailField} key={`plus-wrapper${i}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                                            </StyledWrapper>: userFields.length < trainingQty && <StyledWrapper {...styles.opertorIcons} onClick={addMoreEmailField} key={`plus-wrapper${i}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                                            </StyledWrapper>
                                            }

                                            {userFields.length > 1 && <StyledWrapper {...styles.opertorIcons} key={`minus-wrapper${i}`} onClick={() => removeEmailField(i)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>
                                            </StyledWrapper>}
                                        </GridItem>
                                    </GridItem>
                                </React.Fragment>
                            )
                        })}
                    </GridContainer>
                </StyledWrapper>

                <StyledWrapper {...styles.ctaButtonsWrapper}>
                    <Button {...styles.cancelButton} onClick={closeModalHandler}>
                        {translate("Cancel")}
                    </Button>
                    <Button
                        {...styles.submitButton}
                        type="submit"
                        disabled={isSubmitting || (isSubmitted && !isSubmitEnabled)}
                    >
                        {trainingQty === 0 ? translate("Submit") : translate("Submit and Checkout")}
                    </Button>
                </StyledWrapper>
            </StyledForm>
        </Modal>
    );
};

export default connect(null, mapDispatchToProps)(withHistory(TrainingRegistrationPopup));